function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.3571 7.19036C9.98223 6.56523 10.3334 5.71739 10.3334 4.83333C10.3334 3.94928 9.98223 3.10143 9.3571 2.47631C8.73198 1.85119 7.88414 1.5 7.00008 1.5C6.11603 1.5 5.26818 1.85119 4.64306 2.47631C4.01794 3.10143 3.66675 3.94928 3.66675 4.83333C3.66675 5.71739 4.01794 6.56523 4.64306 7.19036C5.26818 7.81548 6.11603 8.16667 7.00008 8.16667C7.88414 8.16667 8.73198 7.81548 9.3571 7.19036Z",
  stroke: "#9CA3AF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.87529 12.3752C3.96925 11.2812 5.45299 10.6667 7.00008 10.6667C8.54718 10.6667 10.0309 11.2812 11.1249 12.3752C12.2188 13.4692 12.8334 14.9529 12.8334 16.5H1.16675C1.16675 14.9529 1.78133 13.4692 2.87529 12.3752Z",
  stroke: "#9CA3AF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgPersonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person-icon.91a639ea.svg";
export { ForwardRef as ReactComponent };